import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Scanner from "@/pages/Scanner";
import AuthCallback from "@/pages/AuthCallback";
import PaymentReturn from "@/pages/PaymentReturn";
import Dashboard from "@/pages/Dashboard";

function AppRouter() {
  const location = useLocation(); // read hash from here (reactive), not window.location.hash
  // Process a returning OAuth session_id FIRST, before any route/auth check (prevents race conditions).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Scanner />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/payment/success" element={<PaymentReturn />} />
      <Route path="/payment/cancel" element={<PaymentReturn />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
